import React, { Component } from 'react';
import stickybits from 'stickybits';

import MapComp from './map';
import Geocoder from '~/core/scripts/components/Geocoder';
import Portal from '~/core/scripts/components/Portal';

import './map.styl';

class MapWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipVisible: false,
      tooltipPos: false,
      tooltipData: false,
      isMapVisible: false,

      geocoderLatLng: []
    };

    this.updateState = this.updateState.bind(this);
    this.onGeocoderSuccess = this.onGeocoderSuccess.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', () => this.checkMapInputs());
    this.checkMapInputs();

    stickybits('.mapbutton__wrap');
    stickybits('.map__slider');
  }

  updateState(nextState) {
    this.setState(nextState);
  }

  checkMapInputs() {
    const sliderWrapperHeight = document.querySelector('.story').offsetHeight;
    const offset = window.innerHeight * 0.3;
    const mapVisible = window.scrollY >= sliderWrapperHeight - offset;
    const buttonVisible = window.scrollY <= sliderWrapperHeight - offset;

    this.toggleMapInputs(mapVisible);
    this.toggleButton(buttonVisible);
  }

  toggleMapInputs(isMapVisible) {
    this.setState({ isMapVisible });

    const zoomControl = document.querySelector('.leaflet-control-zoom');
    const attrControl = document.querySelector('.leaflet-control-attribution');
    const cta = document.querySelector('.map-comp-wrapper .calltoaction');

    zoomControl && (zoomControl.style.opacity = +isMapVisible);
    attrControl && (attrControl.style.opacity = +isMapVisible);
    cta && (cta.style.opacity = +isMapVisible);
  }

  toggleButton(isButtonVisible) {
    document.querySelector('.mapbutton').style.opacity = +isButtonVisible;
  }

  onGeocoderSuccess(res) {
    const latlng = res.response.view[0].result[0].location.displayPosition;
    this.setState({
      geocoderLatLng: [latlng.latitude + Math.random() / 10000, latlng.longitude + Math.random() / 10000]
    });
  }

  render() {
    return (
      <div className="map-comp-wrapper">
        <MapComp
          updateState={this.updateState}
          geocoderLatLng={this.state.geocoderLatLng}
          config={this.props.config}
          isMapVisible={this.state.isMapVisible}
        />
        <Portal selector=".geocoder__portal">
          <Geocoder onSelect={this.onGeocoderSuccess} isVisible={true} />
        </Portal>
      </div>
    );
  }
}

export default MapWrapper;
